module.exports = __webpack_public_path__ + "static/fr_img-a503fb63159f9b6748c97a72594f34b0.jpg";